import script from "./lotteryRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./lotteryRecord.vue?vue&type=script&setup=true&lang=js"

import "./lotteryRecord.vue?vue&type=style&index=0&id=2d1ae04d&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d1ae04d"]])

export default __exports__